export const LOGIN_PATH = '/login';

export const currentPath = () =>
	`${window.location.pathname}${window.location.search}${window.location.hash}`;

export const redirectToLoginPage = () => {
	if (window.location.pathname === LOGIN_PATH) {
		return;
	}
	const params = new URLSearchParams({ return_to: currentPath() });
	window.location.assign(`${LOGIN_PATH}?${params.toString()}`);
};

// Only a path on this front is followed after login, so the login page cannot be used as an open
// redirect to another site. The path is resolved like the browser will, which strips tabs and
// newlines and reads backslashes as slashes.
export const safeReturnTo = (returnTo?: string) => {
	if (!returnTo?.startsWith('/')) {
		return '/';
	}
	try {
		const url = new URL(returnTo, window.location.origin);
		return url.origin === window.location.origin
			? `${url.pathname}${url.search}${url.hash}`
			: '/';
	} catch {
		return '/';
	}
};
